import React, { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, Tooltip } from "@mui/material";

const BillerOperatorPopupViewer = ({
  operatorCode,
  operatorName,
  serviceName,
  type = "biller",
}) => {
  const [showPopup, setShowPopup] = useState(false);

  if (!operatorCode) return <span>-</span>;

  return (
    <>
      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {operatorCode}
        <Tooltip title="View Details">
          <IconButton
            size="small"
            onClick={() => setShowPopup(true)}
            style={{ padding: 2 }}
          >
            <InfoIcon fontSize="small" color="primary" />
          </IconButton>
        </Tooltip>
      </span>

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ maxWidth: "90%" }}
          >
            <div
              className="modal-content"
              style={{
                width: "300px", // Adjusted for a smaller modal
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "center",
                }}
              >
                <h3 className="modal-title main-title">
                  {type === "biller" ? "Biller Name" : "Service Name"}
                </h3>
              </div>
              <div
                className="scoped-modal modal-body"
                style={{
                  padding: "1.5rem",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <p style={{margin: 0}}>
                  <strong>
                    {type === "biller" ? operatorName || "N/A" : serviceName || "N/A"}
                  </strong>
                </p>
              </div>
              <div
                className="scoped-modal"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "12px",
                  paddingBottom: "0px",
                  gap: "16px",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={() => setShowPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BillerOperatorPopupViewer;